<template>
  <div
    v-if="isMobile && isOpen"
    class="module-sidebar-backdrop"
    @click="onClose"
  ></div>
</template>

<script setup lang="ts">
defineProps<{
  isMobile: boolean;
  isOpen: boolean;
  onClose: () => void;
}>();
</script>

<style scoped>
.module-sidebar-backdrop {
  position: fixed;
  inset: 0;
  top: 50px;
  background: hsl(var(--foreground) / 0.4);
  z-index: 40;
  backdrop-filter: blur(2px);
  cursor: pointer;
}
</style>

